import type React from "react";

import { gridSpacing } from "@utils";

import type { MarginInterface } from "./interfaces";

export const getMargins = ({
  m,
  mx,
  my,
  mt,
  mb,
  mr,
  ml,
}: MarginInterface): React.CSSProperties => {
  if (mr === true) mr = 2;
  if (ml === true) ml = 2;
  if (mt === true) mt = 2;
  if (mb === true) mb = 2;

  return {
    margin: gridSpacing[m as number],
    marginLeft:
      typeof ml !== "undefined"
        ? gridSpacing[ml as number]
        : gridSpacing[mx as number],
    marginRight:
      typeof mr !== "undefined"
        ? gridSpacing[mr as number]
        : gridSpacing[mx as number],
    marginTop:
      typeof mt !== "undefined"
        ? gridSpacing[mt as number]
        : gridSpacing[my as number],
    marginBottom:
      typeof mb !== "undefined"
        ? gridSpacing[mb as number]
        : gridSpacing[my as number],
  };
};
